import smoothscroll from 'smoothscroll-polyfill';

export const scrollToElement = (id: string) => {
  const elm = document.getElementById(id);
  if (elm) {
    const contentPosition = elm.getBoundingClientRect();
    const elmTop = contentPosition.top + window.pageYOffset;
    smoothscroll.polyfill();
    window.scroll({ top: elmTop - 104, behavior: 'smooth' });
  }
};

export const smoothScrollTo = (targetY: number, duration: number) => {
  const startY = window.scrollY;
  const distance = targetY - startY;
  let startTime: number | null = null;

  const step = (currentTime: number) => {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    window.scrollTo(0, startY + distance * progress);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
};
